<template>
  <div id="websiteTemplate">
        <v-container class="pa-0" v-if="!WebsiteTemplate.length">
          <v-layout>
            <router-link to="/admin/websiteTemplate/add">
              <v-flex class="xs12 sm12 mb-5">
                <v-btn fab absolute right class="mr-3 pf-btn-fab">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </router-link>
          </v-layout>
        </v-container>
        <v-layout v-if="WebsiteTemplate.length">
          <v-card class="ma-3">
              <!-- <div class="pf-font-18 ma-4">{{ WebsiteTemplate[0].name }}</div> -->
              <v-layout class="mb-2 ml-3 flex-start">
                  <v-btn class="pf-btn pf-btn-save" @click="save(WebsiteTemplate[0])" :disabled="editIndex === -1">
                      <v-icon size="16" class="pr-1">check_circle</v-icon>
                      <div class="pf-text-center">Save</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-bg-teal" @click="templatePreview(WebsiteTemplate[0])">
                      <v-icon size="16" class="pr-1">remove_red_eye</v-icon>
                      <div class="pf-text-center">Preview</div>
                  </v-btn>
                  <!-- <v-btn class="pf-btn pf-btn-cancel" @click="deleteTemplate(WebsiteTemplate[0])">
                      <v-icon size="16" class="pr-1">delete_outline</v-icon>
                      <div class="pf-text-center">Delete</div>
                  </v-btn> -->
              </v-layout>
              <v-layout>
                  <v-flex class="xs12 sm6">
                  <v-text-field label="Template name" v-model.trim="WebsiteTemplate[0].name" class="required pl-4 required" :rules="[rules.required]" @input="changedTemplateName(0)"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout wrap class="pb-4 pl-4">
                  <v-flex xs12 sm6 class="mt-4 pr-4">
                      <span class="pf-sub-head mb-3 custom-title">Menu background</span>
                      <v-btn block :color="WebsiteTemplate[0].primary_color" @click="colorPickIndex = 0; pickPrimaryColor = !pickPrimaryColor"></v-btn>
                      <chrome-picker :value="WebsiteTemplate[0].primary_color" @input="changePrimaryColor($event, 0)" v-if="colorPickIndex === 0 && pickPrimaryColor"></chrome-picker>
                  </v-flex>
                  <v-flex xs12 sm6 class="mt-4 pr-4">
                      <span class="pf-sub-head mb-3 custom-title">Footer background</span>
                      <v-btn block :color="WebsiteTemplate[0].secondary_color" @click="colorPickIndex = 0; pickSecondaryColor = !pickSecondaryColor"></v-btn>
                      <chrome-picker :value="WebsiteTemplate[0].secondary_color" @input="changeSecondaryColor($event, 0)" v-if="colorPickIndex === 0 && pickSecondaryColor"></chrome-picker>
                  </v-flex>
                  <v-flex xs12 sm6 class="mt-4 pr-4">
                      <span class="pf-sub-head mb-3 custom-title">Banner text color</span>
                      <v-btn block :color="WebsiteTemplate[0].tertiary_color" @click="colorPickIndex = 0; pickTertiaryColor = !pickTertiaryColor"></v-btn>
                      <chrome-picker :value="WebsiteTemplate[0].tertiary_color" @input="changeTertiaryColor($event, 0)" v-if="colorPickIndex === 0 && pickTertiaryColor"></chrome-picker>
                  </v-flex>
                  <v-flex xs12 sm6 class="mt-4 pr-4">
                      <span class="pf-sub-head mb-3 custom-title">Banner text background</span>
                      <v-btn block :color="WebsiteTemplate[0].quaternary_color" @click="colorPickIndex = 0; pickQuaternaryColor = !pickQuaternaryColor"></v-btn>
                      <chrome-picker :value="WebsiteTemplate[0].quaternary_color" @input="changeQuarternaryColor($event, 0)" v-if="colorPickIndex === 0 && pickQuaternaryColor"></chrome-picker>
                  </v-flex>
                  <v-flex xs12 sm6 class="mt-4 pr-4">
                      <span class="pf-sub-head mb-3 custom-title">Main background color</span>
                      <v-btn block :color="WebsiteTemplate[0].background_color" @click="colorPickIndex = 0; pickBackgroundColor = !pickBackgroundColor"></v-btn>
                      <chrome-picker :value="WebsiteTemplate[0].background_color" @input="changeBackgroundColor($event, 0)" v-if="colorPickIndex === 0 && pickBackgroundColor"></chrome-picker>
                  </v-flex>
              </v-layout>
          </v-card>
    </v-layout>
    <v-layout v-else>
      <h5 class="no-data-text">No website templates found. Please add new templates</h5>
    </v-layout>
    <app-modal :active="isPreviewTemplate && previewTemplate !== null" v-if="isPreviewTemplate && previewTemplate" width="90%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="colseTemplatePreview">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ previewTemplate.name }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <!-- <template-preview :template="previewTemplate"></template-preview> -->
            <iframe height="500" width="100%" :src="`https://test.parentfinder.com/profile/MarkLetty/?${getThemeString()}`" class="pf-border-dark-1"></iframe>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="colseTemplatePreview"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store config */

import swal from 'sweetalert2';
import { getCollection, update, remove } from '../../helpers/helpers';
import { Chrome } from 'vue-color';

import AppModal from '../../components/AppModal';
// import WebsiteTemplatePreview from '../../pages/WebsiteTemplate/template';

export default {
  name: 'WebsiteTemplate',
  components: {
    'chrome-picker': Chrome,
    'app-modal': AppModal,
    // 'template-preview': WebsiteTemplatePreview
  },
  data: () => ({
    config: config,
    selectedData: false,
    template: {
      name: '',
      primary_color: '#6a3a36',
      secondary_color: '#fcf8e3',
      tertiary_color: '#dedbcd',
      quaternary_color: '#988876',
      background_color: '#6a3a36'
    },
    pickPrimaryColor: false,
    pickSecondaryColor: false,
    pickTertiaryColor: false,
    pickQuaternaryColor: false,
    pickBackgroundColor: false,
    rules: {
      required: v => !!v.trim() || 'Template name is required.',
    },
    // panelExpand: [],
    editIndex: -1,
    previewTemplate: null,
    isPreviewTemplate: false,
    colorPickIndex: -1
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    WebsiteTemplate: {
      get () {
        return store.state.WebsiteTemplate;
      },
      set (value) {
        store.commit('setWebsiteTemplate', value);
      }
    }
  },
  async created () {
    await this.getWebsiteTemplates();
    /* Set the selected template panel to expand by default */
    // await this.setTemplateExpand();
  },
  methods: {
    async getWebsiteTemplates () {
      if (!this.WebsiteTemplate.length) {
        let entity = `WebsiteTemplate`;
        let { error, data } = await getCollection(entity, true, 0);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.WebsiteTemplate = data;
          }
        }
      }
    },
    getThemeString () {
      let queryString = '';
      queryString += this.previewTemplate.primary_color ? `menu_bg=${this.previewTemplate.primary_color.replace('#', '')}` : null;
      queryString += this.previewTemplate.secondary_color ? `&footer_bg=${this.previewTemplate.secondary_color.replace('#', '')}` : null;
      queryString += this.previewTemplate.tertiary_color ? `&banner_text_color=${this.previewTemplate.tertiary_color.replace('#', '')}` : null;
      queryString += this.previewTemplate.quaternary_color ? `&banner_text_bg=${this.previewTemplate.quaternary_color.replace('#', '')}` : null;
      queryString += this.previewTemplate.background_color ? `&main_bg=${this.previewTemplate.background_color.replace('#', '')}` : null;
      return queryString;
    },
    // async setTemplateExpand () {
    //   if (this.WebsiteTemplate.length) {
    //     /* Expand the first one */
    //     this.panelExpand = this.WebsiteTemplate.map((x, i) => i === 0);
    //   }
    // },
    templatePreview (item) {
      this.previewTemplate = item;
      this.isPreviewTemplate = true;
    },
    colseTemplatePreview () {
      this.previewTemplate = null;
      this.isPreviewTemplate = false;
    },
    async save () {
      this.selectedData = false;
      let editData = JSON.parse(JSON.stringify(this.WebsiteTemplate[this.editIndex]));
      let { error, data, status } = await update('WebsiteTemplate', editData, editData.id);
      if (error) {
        console.log('error', error);
        this.selectedData = true;
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        this.editIndex = -1;
        swal.fire({
          type: 'success',
          title: 'Website template was updated successfully',
          showConfirmButton: false,
          timer: 2500
        });
      }
      this.pickPrimaryColor = this.pickSecondaryColor = this.pickTertiaryColor = this.pickQuaternaryColor = false;
    },
    /* deleteTemplate (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('WebsiteTemplate', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.WebsiteTemplate.indexOf(item);
              this.WebsiteTemplate.splice(index, 1);
              swal.fire(
                'Deleted!',
                `The website template "${item.name}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    }, */
    changePrimaryColor (newColor, itemIndex) {
      this.editIndex = itemIndex;
      this.WebsiteTemplate[itemIndex].primary_color = newColor.hex8;
      this.selectedData = true;
    },
    changeSecondaryColor (newColor, itemIndex) {
      this.editIndex = itemIndex;
      this.WebsiteTemplate[itemIndex].secondary_color = newColor.hex8;
      this.selectedData = true;
    },
    changeTertiaryColor (newColor, itemIndex) {
      this.editIndex = itemIndex;
      this.WebsiteTemplate[itemIndex].tertiary_color = newColor.hex8;
      this.selectedData = true;
    },
    changeQuarternaryColor (newColor, itemIndex) {
      this.editIndex = itemIndex;
      this.WebsiteTemplate[itemIndex].quaternary_color = newColor.hex8;
      this.selectedData = true;
    },
    changeBackgroundColor (newColor, itemIndex) {
      this.editIndex = itemIndex;
      this.WebsiteTemplate[itemIndex].background_color = newColor.hex8;
      this.selectedData = true;
    },
    changedTemplateName (itemIndex) {
      this.editIndex = itemIndex;
      this.selectedData = true;
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/WebsiteTemplate/list.vue